import {NotificationService} from "../../services/NotificationService";
import {BaseEntity} from "../../entities/BaseEntity";
import { StateService } from "@uirouter/angularjs";
import { ServerImportModel } from "../../models/serverimport/ServerImportModel";

export class ServerImportFixErrorsCtrl<T extends BaseEntity>{
    public static $inject = ['$q','$scope', '$state', 'ImportModel', 'Upload', 'NotificationService'];
    working: boolean = false;
    public file: any;
    errorsGridOptions: any;
    constructor(public $q: ng.IQService,
        public $scope: any,
        public stateService: StateService,
        public model: ServerImportModel<T>,
        public upload: ng.angularFileUpload.IUploadService,
        public notificationService: NotificationService) {
        this.$scope.vm = this;
        this.errorsGridOptions = {
            columnDefs: [{ field: 'row', name: 'Row', width: 100 }, { field: 'error', name: 'Error', width: 500 }],
            data: this.model.errors,
        };
    }
    submit() {
        if (this.file == null) {
            this.notificationService.notifyError("Please upload a file first.");
            return;
        }
        this.working = true;
        this.upload.upload<string>({
            url: '/api/' + this.model.getControllersName() + '/serverimportreupload?fileid=' + this.model.fileId,
            data: { file: this.file },
            method: 'post'
        }).then((data) => {
            var fileId = data.data;
            //next save fileId to model for processing
            this.model.fileId = fileId;
            this.model.startImport(true).then((ok) => {
                this.working = false;
                if (ok) {
                    if (this.model.errors.length == 0) {
                        this.stateService.go(this.model.getRoute("confirm"));
                    }
                    else {
                        this.errorsGridOptions.data = this.model.errors;
                    }
                }
            }).catch((exc) => {
                this.notificationService.notifyError("Got error in testing import:" + exc);
                this.working = false;
            })    
        })
        .catch((exc) => {
            this.notificationService.notifyError("Error in uploading import file:" + exc);
        });
    }
}
